import { render, staticRenderFns } from "./LogsTableSkeletonItem.vue?vue&type=template&id=303dd6e2&scoped=true"
import script from "./LogsTableSkeletonItem.vue?vue&type=script&lang=js"
export * from "./LogsTableSkeletonItem.vue?vue&type=script&lang=js"
import style0 from "./LogsTableSkeletonItem.vue?vue&type=style&index=0&id=303dd6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303dd6e2",
  null
  
)

export default component.exports